import {React,useEffect,useState,useContext} from 'react'
import axios from 'axios'
import './rightbar.css'
import { Users } from '../../dummy_data' 
import Online from '../online/Online'
import {Link} from 'react-router-dom'
import { Add, Remove } from "@material-ui/icons";
import {useParams} from 'react-router-dom'
import { AuthContext } from "../../context/AuthContext";

export default function Rightbar() {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const [friends,setFriends] = useState([])
  const { user: currentUser,dispatch} = useContext(AuthContext);
  const [pageUser, setPageUser] = useState({})
  const username = useParams().username;

  const [followed, setFollowed] = useState(false);
  const [usersall,setUsersall] = useState([]);
    useEffect(() => {
        const getallusers = async () => {
            try {
                const allusers = await axios.get('/users/all')
                setUsersall(allusers.data)
            } catch (e) {
                console.log(e)
            }
        }
        getallusers();
    }, []);


  useEffect(() => {
    const fetchUser = async () => {
      const res = await axios.get("/users?username="+username);
      setPageUser(res.data)
      // setFollowed(currentUser.following.includes(pageUser._id))
      setFollowed(currentUser.following.includes(pageUser._id))
    }
    fetchUser();
  },[pageUser])
  console.log(followed)

const handleClick = async () => {
    try {
      if (followed) {
        await axios.put(`/users/${pageUser._id}/unfollow`, {
          userId: currentUser._id,
        });
        dispatch({ type: "UNFOLLOW", payload: pageUser._id });
      } else {
        await axios.put(`/users/${pageUser._id}/follow`, {
          userId: currentUser._id,
        });
        dispatch({ type: "FOLLOW", payload: pageUser._id });
      }
      setFollowed(!followed);
    } catch (err) {
      console.log(err)
    }
  };




  useEffect(() => {
    const getFriends = async () => {
      try{
        const friendlist = await axios.get('/users/friends/'+pageUser._id)
        setFriends(friendlist.data)
    }catch(e){
      console.log(e)
    }
    }
    getFriends();
    }, [pageUser]);

  const HomeRightBar = () => {
      return ( 
        <>
          <div className='birthdayContainer'>
          <img src={PF+"/Birthday.png"} alt="" className='birthdayImg' />
          <span><b>Utkarsh</b> and <b>3</b> other friends have birthdays today</span>
        </div>


          <img src = {PF+"/nature.jpg"}
          alt = 'advertisement'
          className = 'rightbarAd' />
          <h4 className='rightbarTitle'>All Users</h4> {
              usersall.map(u => (
                  <Online key = {u.id} user = {u}/>
              ))
          } 
          </>
      )
  }
  const ProfileRightBar = () => {
    return (
      <>
      {pageUser.username !== currentUser.username && (
          <button className="rightbarFollowButton" onClick={handleClick}>
            {followed ? "Unfollow" : "Follow"}
            {followed ? <Remove /> : <Add />}
          </button>
        )}
       <h4 className="rightbarTitle"><b>User information</b></h4>
        <div className="rightbarInfo">
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">City:</span>
            <span className="rightbarInfoValue">{pageUser.city}</span>
          </div>
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">From:</span>
            <span className="rightbarInfoValue">{pageUser.from}</span>
          </div>
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">Relationship:</span>
            <span className="rightbarInfoValue">
             {(() => {
                switch (pageUser.relationship) {
          case 1 :   return "Single";
          case 2: return "In relationship";
          case 3:  return "Married";
          default:      return "We don't know!!";
        }
      })()}
            </span>
          </div>
        </div>
        <h4 className="rightbarTitle"><b>User friends</b></h4>
        <div className="rightbarFollowings">
          {friends.map((friend) => (
            <Link to={"/profile/"+friend.username}>
            <div className="rightbarFollowing">
            <img
              src={friend.profilePicture? PF+friend.profilePicture : PF+'no_avatar/image_proxy.jpeg'}
              alt=""
              className="rightbarFollowingImg"
            />
            <span className="rightbarFollowingName">{friend.username}</span>
          </div>
          </Link>
            )
          )}
          
          
        </div>
      </>
      )
  }

  return (
    <div className='rightbar'>
      <div className='rightbarWrapper'>
        {username === undefined ? <HomeRightBar/>:<ProfileRightBar/>}
      </div>
          
    </div>

    )
}